import React, { Component } from 'react';
import { WithContext as ReactTags } from 'react-tag-input';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';

@inject('tagStore')
@observer
class Tags extends Component {
  state = {
    tags: []
  }
  @observable suggestions = [];

  componentWillMount() {
    const { tagStore, tags } = this.props;
    if (!tagStore.isLoading && !tagStore.items.length) tagStore.fetchItems();
    // this.setState({ tags });
    this.reset(tags);
  }

  componentWillReceiveProps(nextProps) {
    this.reset(nextProps.tags);
  }

  reset = (tags) => {
    const { tagStore } = this.props;
    if (!tagStore.items.length) {
      setTimeout(() => {
        this.reset(tags);
      }, 300);
    } else {
      this.setState({ tags }, () => {
        const tags = this.state.tags.map(item => item.name);
        this.suggestions.replace(
          tagStore.items
            .map(item => item.name)
            .filter(item => tags.indexOf(item) === -1)
        );
      });
    }
  }

  componentWillUnmount() {
    this.setState({ tags: [] });
  }

  handleDelete = (i) => {
    let tags = this.state.tags;
    tags.splice(i, 1);
    this.setState({ tags });
    this.props.onChange(tags);
  }

  handleAddition = (tag) => {
    const { tagStore } = this.props;
    if (this.suggestions.indexOf(tag) === -1) {
      return;
    }
    // const tagNames = this.suggestions.map(item => item.name);
    let tags = this.state.tags;
    const foundTag = tagStore.items.find(item => item.name === tag);
    tags.push(foundTag.asJson);
    this.setState({ tags });
    this.props.onChange(tags);
  }

  handleDrag = (tag, currPos, newPos) => {
    let tags = this.state.tags;

    // mutate array
    tags.splice(currPos, 1);
    tags.splice(newPos, 0, tag);

    // re-render
    this.setState({ tags });
    this.props.onChange(tags);
  }

  render() {
    // const { tagStore } = this.props;
    const tags = this.state.tags;
    // let suggestions = this.state.suggestions;
    // console.log('this.suggestions', this.suggestions);

    return (
      <div className='tags'>
        <ReactTags
          tags={tags.slice()}
          suggestions={this.suggestions.slice()}
          handleDelete={this.handleDelete}
          handleAddition={this.handleAddition}
          handleDrag={this.handleDrag}
          labelField={'name'}
          minQueryLength={1}
          autofocus={false}
        />
      </div>
    );
  }
}

export default Tags;



// WEBPACK FOOTER //
// ./src/components/Tags.js